import React from 'react'
import classes from './Todo.module.css'


function Todo(props) {
 

 
  return (
   
    <div className={classes.content}>
    <h5 className={classes.heading}>Advice #{props.Advice[0].id}</h5>
    <h3 className={classes.advice}>"{props.Advice[0].advice}"</h3>
    <span className={classes.circle}>
      <img src='./icon-dice.svg' alt="icon" />
    </span>
    </div>

  );
  }


export default Todo;
